<template>
  <div class="dvSectionTitleOpts">
    <div class="dvSectionTitleOpts-title">
      <span class="icon-fs_search"></span>Search Results
    </div> <!-- dvSectionTitleOpts-title -->
    <div class="dvSectionTitleOpts-options valign-wrapper">
      <div class="dvResultsFilterBy">
        Filter by:
      </div>
      <div
        :class="{ filterActive: this.$route.params.filter_by == 'clients' ? true : false }"
        @click="search('clients')"
        class="waves-effect waves-light btn-Pill">
        <div class="label">Clients</div>
      </div> <!-- btn-Pill -->
      <div class="waves-effect waves-light btn-Pill"
        :class="{ filterActive: this.$route.params.filter_by == 'members' ? true : false }"
        @click="search('members')"
        >
        <div class="label">Members</div>
      </div> <!-- btn-Pill -->
      <div class="waves-effect waves-light btn-Pill"
        v-if="$getConstRole('ROLE_SUB_ADMIN') == $store.getters.getCurrentUserRole"
        :class="{ filterActive: this.$route.params.filter_by == 'teams' ? true : false }"
        @click="search('teams')"
        >
        <div class="label">Teams</div>
      </div> <!-- btn-Pill -->
    </div> <!-- dvSectionTitleOpts-options -->
  </div> <!-- dvSectionTitleOpts -->
</template>

<script>
  export default {
    name: 'search-results-nav',
    props: ['q'],
    data: () => ({

    }),
    watch: {

    },
    computed: {

    },
    methods: {
      search (filter_by){
        this.$router.push({ name: 'search_results', params: { filter_by: filter_by } ,query: { q: this.q, click: 'nav' } })
      }
    },
    mounted() {

    },
    components: {
    }
  }
</script>
